import './style.scss';

export function hero_block() {
  const block = document.querySelector('.hero_block');
  if (!block) return;
  
}
